import { DATE_FORMAT, formatDate, Locale } from '@nemuru-eng/js-api-client';

export class CustomDate {
  private value: Date;

  constructor(date?: Date) {
    this.value = this.withoutTime(date || new Date());
  }

  private withoutTime(date: Date): Date {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  }

  public subtractDays(days: number): this {
    const date = new Date(this.value);
    date.setDate(date.getDate() - days);
    this.value = date;
    return this;
  }

  public formatDate(format?: DATE_FORMAT, locale?: Locale): string {
    return formatDate(this.value, format, locale);
  }

  public isSameDay(date: Date): boolean {
    return (
      this.value.getFullYear() === date.getFullYear() &&
      this.value.getMonth() === date.getMonth() &&
      this.value.getDate() === date.getDate()
    );
  }

  public isWithinDaysAgo(date: Date, days: number): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const daysAgo = new Date(today);
    daysAgo.setDate(today.getDate() - days);

    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    return date >= daysAgo && date <= endOfDay;
  }

  public get date(): Date {
    return new Date(this.value);
  }
}
